import FormattedMessage from 'I18n/components/FormattedMessage';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';

// @ts-expect-error svg import
import COMMERCE_HUB_QUOTE_ICON from 'bender-url!../../img/commerceHubFeatures/icons-deal-tracking.svg';
// @ts-expect-error svg import
import COMMERCE_HUB_INVOICES_ICON from 'bender-url!../../img/commerceHubFeatures/icons-email-templates.svg';
// @ts-expect-error svg import
import COMMERCE_HUB_PAYMENT_ICON from 'bender-url!../../img/commerceHubFeatures/icons-payment-links-grey.svg';
// @ts-expect-error svg import
import COMMERCE_HUB_SUBSCRIPITON_ICON from 'bender-url!../../img/commerceHubFeatures/icons-recurring-payments.svg';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeatureHighlightsConfig = [{
  featureName: 'invoices',
  featureIcon: COMMERCE_HUB_INVOICES_ICON
}, {
  featureName: 'paymentLinks',
  featureIcon: COMMERCE_HUB_PAYMENT_ICON
}, {
  featureName: 'quotes',
  featureIcon: COMMERCE_HUB_QUOTE_ICON
}, {
  featureName: 'subscriptions',
  featureIcon: COMMERCE_HUB_SUBSCRIPITON_ICON
}];
const FeatureHighlight = ({
  featureName,
  featureIcon
}) => {
  return /*#__PURE__*/_jsx(MediaObject, {
    itemLeft: /*#__PURE__*/_jsx(View, {
      inlineSize: "75px",
      blockSize: "75px",
      children: /*#__PURE__*/_jsx(Image, {
        src: featureIcon,
        inlineSize: "100%"
      })
    }),
    children: /*#__PURE__*/_jsxs(View, {
      marginInlineStart: "600",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h7",
        "aria-level": 3,
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `pricingPage.pages.commerce.featureHighlights.${featureName}.title`
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricingPage.pages.commerce.featureHighlights.${featureName}.description`
      })]
    })
  });
};
export const BringCommerceFeatureHighlights = () => {
  return /*#__PURE__*/_jsx(List, {
    children: FeatureHighlightsConfig.map(({
      featureName,
      featureIcon
    }) => /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "800",
      children: /*#__PURE__*/_jsx(FeatureHighlight, {
        featureName: featureName,
        featureIcon: featureIcon
      }, featureName)
    }, featureName))
  });
};